module.exports = __webpack_public_path__ + "img/reactor-connect-patches.8a910dc0.png";